import App from '../modules/app'

export default class AppSingleton {

    static app:App = null;

    /**
     * @returns {App}
     */
    static getInstance() {
        if (this.app === null) {
            this.app = new App();
        }
        return this.app;
    }
}